import { useCallback, useEffect, useRef } from 'react';

export const LEAGUE_HOME_IDLE_POLL_MS = 60_000;
export const LEAGUE_HOME_ACTIVE_POLL_MS = 15_000;
export const LEAGUE_HOME_FOCUS_STALE_MS = 10_000;

export function useLeagueHomeLivePolling(
  loadFn: () => void | Promise<void>,
  hasLiveActivity: boolean
): void {
  const lastFetchAtRef = useRef<number>(Date.now());

  const loadWithTimestamp = useCallback(async () => {
    await loadFn();
    lastFetchAtRef.current = Date.now();
  }, [loadFn]);

  useEffect(() => {
    const intervalMs = hasLiveActivity ? LEAGUE_HOME_ACTIVE_POLL_MS : LEAGUE_HOME_IDLE_POLL_MS;
    const intervalId = window.setInterval(() => {
      if (document.hidden) return;
      void loadWithTimestamp();
    }, intervalMs);
    return () => window.clearInterval(intervalId);
  }, [hasLiveActivity, loadWithTimestamp]);

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.hidden) return;
      if (Date.now() - lastFetchAtRef.current > LEAGUE_HOME_FOCUS_STALE_MS) {
        void loadWithTimestamp();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [loadWithTimestamp]);
}
